// extracted by mini-css-extract-plugin
module.exports = {"balance":"style_balance__29agw","blockInvoice":"style_blockInvoice__2awtS"};